module.exports = "/_next/static/images/transfer-ffec33d0a0f76c9e17f073380f7b556e.svg";